var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMagnifierLine = function SvgMagnifierLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: 0,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.281.094A6.195 6.195 0 0 0 .094 6.28 6.195 6.195 0 0 0 6.28 12.47c1.42 0 2.725-.486 3.77-1.293l4.497 4.497a.796.796 0 0 0 1.125-1.125l-4.497-4.497a6.15 6.15 0 0 0 1.293-3.77A6.195 6.195 0 0 0 6.28.094m0 1.375a4.82 4.82 0 0 1 4.813 4.812 4.82 4.82 0 0 1-4.813 4.813A4.82 4.82 0 0 1 1.47 6.28 4.82 4.82 0 0 1 6.28 1.47"
  })));
};
export default SvgMagnifierLine;